export default __webpack_public_path__ + "static/media/logo_b.c44dbc67.png";